import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_MTA {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	GetMTACardUsageInfo(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "StudentMTA/GetMTACardUsageInfo?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
